module.exports = __webpack_public_path__ + "img/login-support.d3124f1e.png";